var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckboxUnchecked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "25px",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "52FB2FB9-74FE-4D32-BF77-57B0A04B09B9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    transform: "translate(-841.000000, -1248.000000)",
    fill: "#2648A4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component/icon/ic_Uncheck-Copy-3",
    transform: "translate(841.000000, 1248.184874)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,2.4 L18,2.4 C19.9882251,2.4 21.6,4.0117749 21.6,6 L21.6,18 C21.6,19.9882251 19.9882251,21.6 18,21.6 L6,21.6 C4.0117749,21.6 2.4,19.9882251 2.4,18 L2.4,6 C2.4,4.0117749 4.0117749,2.4 6,2.4 Z M6,3.6 C4.6745166,3.6 3.6,4.6745166 3.6,6 L3.6,18 C3.6,19.3254834 4.6745166,20.4 6,20.4 L18,20.4 C19.3254834,20.4 20.4,19.3254834 20.4,18 L20.4,6 C20.4,4.6745166 19.3254834,3.6 18,3.6 L6,3.6 Z",
    id: "Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxUnchecked);
export default __webpack_public_path__ + "static/media/checkbox_unchecked.03258e66e2512b1bc777fedaa81b5a8a.svg";
export { ForwardRef as ReactComponent };